module.exports = __webpack_public_path__ + "static/media/invito.6bb30724.png";